<div
  *ngIf="showAvatar"
  class="avatar-host"
  [class.panel-below]="panelBelow"
  [class.roaming]="roaming"
  [class.size-small]="prefs.size === 'small'"
  [class.size-medium]="prefs.size === 'medium'"
  [class.size-large]="prefs.size === 'large'"
  [ngClass]="'motion-' + effectiveMotionPreset"
  [class.reaction-happy]="reaction === 'happy'"
  [class.reaction-alert]="reaction === 'alert'"
  [class.reaction-thinking]="reaction === 'thinking'"
  [class.reaction-wave]="reaction === 'wave'"
  [class.emotion-happy]="emotion === 'happy'"
  [class.emotion-worried]="emotion === 'worried'"
  [class.emotion-tired]="emotion === 'tired'"
  [class.emotion-focused]="emotion === 'focused'"
  [class.emotion-celebrating]="emotion === 'celebrating'"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
  [style.--avatar-primary]="prefs.primaryColor"
  [style.--avatar-secondary]="prefs.secondaryColor"
  [style.--motion-shift]="motionIntensityPx + 'px'"
  [style.--motion-duration]="motionDurationSeconds + 's'"
>
  <div class="avatar-speech" *ngIf="speech && !open" aria-live="polite">
    {{ speech }}
  </div>

  <span
    *ngIf="reaction === 'wave'"
    class="gesture-hand"
    aria-hidden="true"
  >
    👋
  </span>

  <div
    *ngIf="showMusicalNotes"
    class="mascot-effect musical-notes"
    aria-hidden="true"
  >
    <span>♪</span><span>♫</span><span>♪</span>
  </div>

  <div
    *ngIf="showConfetti"
    class="mascot-effect confetti-effect"
    aria-hidden="true"
  >
    <i></i><i></i><i></i><i></i><i></i><i></i>
  </div>

  <div
    *ngIf="showSleepEffect"
    class="mascot-effect sleep-effect"
    aria-hidden="true"
  >
    <span>Z</span><span>z</span><span>z</span>
  </div>

  <div
    *ngIf="showThinkEffect"
    class="mascot-effect think-effect"
    aria-hidden="true"
  >
    <span>•</span><span>•</span><span>•</span>
  </div>

  <section
    class="assistant-panel"
    *ngIf="open"
    role="dialog"
    aria-label="Asistente ZIVO"
    (pointerdown)="$event.stopPropagation()"
  >
    <header class="panel-header">
      <div>
        <span class="panel-kicker">Asistente operativo</span>
        <h3>{{ panelTitle }}</h3>
      </div>

      <button
        type="button"
        class="icon-button"
        aria-label="Cerrar asistente"
        (click)="closePanel()"
      >
        <span class="material-icons">close</span>
      </button>
    </header>

    <div class="panel-status">
      <span class="status-dot"></span>
      Sin IA · conectado a ZIVO y Outlook
    </div>

    <p class="panel-message">{{ panelMessage }}</p>

    <ng-container *ngIf="mode === 'home'">
      <button
        *ngIf="suggestedAction"
        type="button"
        class="suggested-action"
        (click)="runSuggestedCommand()"
      >
        <span class="material-icons">{{ suggestedAction.icon }}</span>
        <span>
          <small>Sugerencia</small>
          <strong>{{ suggestedAction.label }}</strong>
        </span>
        <span class="material-icons arrow">arrow_forward</span>
      </button>

      <div class="quick-grid">
        <button
          *ngFor="let action of visibleQuickActions; trackBy: trackQuickAction"
          type="button"
          class="quick-action"
          [class.primary]="action.primary"
          (click)="runCommand(action.command)"
        >
          <span class="material-icons">{{ action.icon }}</span>
          <span>{{ action.label }}</span>
        </button>

        <button
          type="button"
          class="quick-action settings-action"
          (click)="openSettings()"
        >
          <span class="material-icons">tune</span>
          <span>Configurar</span>
        </button>
      </div>

      <form class="command-box" (ngSubmit)="submitCommand()">
        <span class="material-icons">terminal</span>
        <input
          type="text"
          name="avatarCommand"
          [(ngModel)]="commandInput"
          autocomplete="off"
          placeholder='Escribe: "qué debo hacer hoy"'
          aria-label="Acción para el asistente"
        />
        <button
          type="submit"
          class="send-command"
          [disabled]="!commandInput.trim() || busy"
          aria-label="Ejecutar acción"
        >
          <span class="material-icons">arrow_upward</span>
        </button>
      </form>

      <div class="command-help">
        <span>También entiende:</span>
        <code>hoy</code>
        <code>mañana</code>
        <code>esta semana</code>
        <code>reuniones</code>
        <code>recuérdame</code>
        <code>novedades</code>
        <code>todos los viernes</code>
        <code>baila</code>
        <code>canta</code>
        <code>duerme</code>
        <code>celebra</code>
      </div>
    </ng-container>

    <div class="loading-state" *ngIf="busy">
      <span class="loading-ring"></span>
      <span>Consultando…</span>
    </div>

    <ng-container *ngIf="mode === 'agenda' && !busy">
      <div class="result-list" *ngIf="meetings.length; else noAgendaResults">
        <article
          class="result-card"
          *ngFor="let meeting of meetings; trackBy: trackMeeting"
        >
          <div class="result-icon">
            <span class="material-icons">
              {{ meeting.category === 'REMINDER' ? 'notifications_active' : 'event' }}
            </span>
          </div>

          <div class="result-content">
            <div class="result-heading">
              <strong>{{ meeting.subject }}</strong>
              <span class="result-badge" *ngIf="meeting.category === 'REMINDER'">
                Recordatorio
              </span>
            </div>

            <span class="result-date">{{ formatDateTime(meeting.start_at) }}</span>
            <p *ngIf="meeting.description">{{ meeting.description }}</p>

            <div class="meeting-provider-row" *ngIf="meeting.provider === 'MICROSOFT_TEAMS'">
              <span class="meeting-provider">
                <span class="material-icons">video_camera_front</span>
                Microsoft Teams
              </span>

              <button
                *ngIf="isTeamsMeeting(meeting)"
                type="button"
                class="join-meeting-button"
                (click)="openMeetingLink(meeting, $event)"
              >
                <span class="material-icons">open_in_new</span>
                Unirme
              </button>
            </div>

            <div
              class="reminder-actions"
              *ngIf="meeting.category === 'REMINDER' && !meeting.recurrence_pattern"
            >
              <button
                type="button"
                class="reminder-complete"
                [disabled]="!!reminderActionKey"
                (click)="completeReminder(meeting, $event)"
              >
                <span class="material-icons">check_circle</span>
                Hecho
              </button>

              <div class="snooze-row">
                <button
                  type="button"
                  [disabled]="!!reminderActionKey"
                  (click)="snoozeReminder(meeting, 5, $event)"
                >+5m</button>
                <button
                  type="button"
                  [disabled]="!!reminderActionKey"
                  (click)="snoozeReminder(meeting, 15, $event)"
                >+15m</button>
                <button
                  type="button"
                  [disabled]="!!reminderActionKey"
                  (click)="snoozeReminder(meeting, 60, $event)"
                >+1h</button>
                <button
                  type="button"
                  [disabled]="!!reminderActionKey"
                  (click)="snoozeReminder(meeting, 'tomorrow', $event)"
                >Mañana</button>
              </div>
            </div>

            <div
              class="recurrence-note"
              *ngIf="meeting.category === 'REMINDER' && meeting.recurrence_pattern"
            >
              <span class="material-icons">repeat</span>
              Serie recurrente · gestiona la serie desde Calendario
            </div>
          </div>
        </article>
      </div>

      <ng-template #noAgendaResults>
        <div class="empty-state">
          <span class="material-icons">event_available</span>
          <strong>Todo despejado</strong>
          <span>No hay elementos para mostrar.</span>
        </div>
      </ng-template>

      <div class="panel-actions">
        <button type="button" class="secondary-button" (click)="openCalendar()">
          <span class="material-icons">calendar_month</span>
          Abrir calendario
        </button>
        <button
          type="button"
          class="primary-button"
          (click)="startReminderWizard()"
        >
          <span class="material-icons">add</span>
          Recordatorio
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'notifications' && !busy">
      <div class="result-list" *ngIf="notifications.length; else noNotifications">
        <article
          class="result-card notification-card"
          *ngFor="let item of notifications; trackBy: trackNotification"
        >
          <div class="result-icon alert">
            <span class="material-icons">notifications</span>
          </div>
          <div class="result-content">
            <strong>{{ item.notification.message }}</strong>
            <span class="result-date">
              {{ formatDateTime(item.notification.created_at) }}
            </span>
          </div>
        </article>
      </div>

      <ng-template #noNotifications>
        <div class="empty-state">
          <span class="material-icons">notifications_none</span>
          <strong>Sin novedades</strong>
          <span>No tienes notificaciones pendientes.</span>
        </div>
      </ng-template>

      <div class="panel-actions single">
        <button
          type="button"
          class="secondary-button"
          (click)="mode = 'home'; panelTitle = prefs.name; panelMessage = '¿Qué necesitas hacer?'"
        >
          Volver
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'reminder'">
      <div class="wizard-progress">
        <span [class.active]="reminderStep >= 1">1</span>
        <i [class.active]="reminderStep >= 2"></i>
        <span [class.active]="reminderStep >= 2">2</span>
        <i [class.active]="reminderStep >= 3"></i>
        <span [class.active]="reminderStep >= 3">3</span>
        <i [class.active]="reminderStep >= 4"></i>
        <span [class.active]="reminderStep >= 4">4</span>
      </div>

      <div class="wizard-step" *ngIf="reminderStep === 1">
        <div class="step-heading">
          <span class="material-icons">event</span>
          <div>
            <strong>¿Qué fecha?</strong>
            <small>Elige cuándo debe aparecer el recordatorio.</small>
          </div>
        </div>

        <div class="choice-row">
          <button type="button" (click)="chooseToday()">Hoy</button>
          <button type="button" (click)="chooseTomorrow()">Mañana</button>
        </div>

        <label class="form-field">
          <span>Elegir fecha</span>
          <input
            type="date"
            [(ngModel)]="reminderDraft.date"
            name="reminderDate"
            (change)="chooseReminderDate(reminderDraft.date)"
          />
        </label>
      </div>

      <div class="wizard-step" *ngIf="reminderStep === 2">
        <div class="step-heading">
          <span class="material-icons">schedule</span>
          <div>
            <strong>¿A qué hora?</strong>
            <small>{{ reminderDraft.date }}</small>
          </div>
        </div>

        <div class="choice-row three">
          <button type="button" (click)="chooseReminderTime('08:00')">08:00</button>
          <button type="button" (click)="chooseReminderTime('12:00')">12:00</button>
          <button type="button" (click)="chooseReminderTime('15:00')">15:00</button>
        </div>

        <label class="form-field">
          <span>Elegir hora</span>
          <input
            type="time"
            [(ngModel)]="reminderDraft.time"
            name="reminderTime"
            (keyup.enter)="chooseReminderTime(reminderDraft.time)"
            aria-label="Hora del recordatorio"
          />
        </label>
        <div class="inline-error" *ngIf="reminderError">{{ reminderError }}</div>
        <button type="button" class="time-continue" (click)="chooseReminderTime(reminderDraft.time)">
          Continuar con esta hora
        </button>

        <button type="button" class="text-button" (click)="reminderStep = 1">
          ← Cambiar fecha
        </button>
      </div>

      <div class="wizard-step" *ngIf="reminderStep === 3">
        <div class="step-heading">
          <span class="material-icons">edit_note</span>
          <div>
            <strong>¿Qué quieres recordar?</strong>
            <small>Esto será el título en Outlook.</small>
          </div>
        </div>

        <label class="form-field">
          <span>Recordatorio</span>
          <input
            type="text"
            [(ngModel)]="reminderDraft.subject"
            name="reminderSubject"
            maxlength="180"
            placeholder="Ej. Llamar al Ing. Roosevelt"
            (keyup.enter)="continueReminderContent()"
          />
        </label>

        <label class="form-field">
          <span>Nota opcional</span>
          <textarea
            [(ngModel)]="reminderDraft.description"
            name="reminderDescription"
            rows="3"
            maxlength="1000"
            placeholder="Agrega un detalle si hace falta"
          ></textarea>
        </label>

        <div class="inline-error" *ngIf="reminderError">
          {{ reminderError }}
        </div>

        <div class="panel-actions">
          <button type="button" class="secondary-button" (click)="reminderStep = 2">
            Atrás
          </button>
          <button
            type="button"
            class="primary-button"
            (click)="continueReminderContent()"
          >
            Continuar
          </button>
        </div>
      </div>

      <div class="wizard-step" *ngIf="reminderStep === 4">
        <div class="step-heading">
          <span class="material-icons">fact_check</span>
          <div>
            <strong>Confirmar recordatorio</strong>
            <small>Se guardará en ZIVO y Outlook.</small>
          </div>
        </div>

        <div class="reminder-summary">
          <div>
            <span class="material-icons">event</span>
            <span>{{ reminderDraft.date }}</span>
          </div>
          <div>
            <span class="material-icons">schedule</span>
            <span>{{ reminderDraft.time }}</span>
          </div>
          <div>
            <span class="material-icons">notifications</span>
            <span>{{ reminderDraft.subject }}</span>
          </div>
        </div>

        <label class="form-field compact">
          <span>Repetir</span>
          <select
            [(ngModel)]="reminderRecurrenceMode"
            name="reminderRecurrenceMode"
          >
            <option value="none">No repetir</option>
            <option value="daily">Todos los días</option>
            <option value="weekly">Cada semana</option>
            <option value="monthly">Cada mes</option>
          </select>
        </label>

        <div
          class="recurrence-note"
          *ngIf="reminderRecurrenceMode !== 'none'"
        >
          <span class="material-icons">repeat</span>
          Se repetirá durante 1 año
          <span *ngIf="reminderRecurrenceMode === 'weekly' && reminderRecurrenceDay">
            · {{ reminderRecurrenceDay }}
          </span>
        </div>

        <label class="form-field compact">
          <span>Avisarme antes</span>
          <select
            [(ngModel)]="reminderDraft.reminderMinutes"
            name="reminderMinutes"
          >
            <option [ngValue]="0">A la hora</option>
            <option [ngValue]="5">5 minutos</option>
            <option [ngValue]="15">15 minutos</option>
            <option [ngValue]="30">30 minutos</option>
            <option [ngValue]="60">1 hora</option>
          </select>
        </label>

        <div class="inline-error" *ngIf="reminderError">
          {{ reminderError }}
        </div>

        <div class="panel-actions">
          <button type="button" class="secondary-button" (click)="reminderStep = 3">
            Atrás
          </button>
          <button
            type="button"
            class="primary-button"
            [disabled]="busy"
            (click)="saveReminder()"
          >
            <span class="material-icons">check</span>
            Guardar
          </button>
        </div>
      </div>

      <button
        *ngIf="!busy"
        type="button"
        class="cancel-wizard"
        (click)="cancelReminder()"
      >
        Cancelar recordatorio
      </button>
    </ng-container>
  </section>

  <button
    type="button"
    class="avatar-button"
    [attr.aria-label]="'Abrir ' + (prefs.name || 'asistente ZIVO')"
    (pointerdown)="onPointerDown($event)"
    (click)="togglePanel($event)"
    (dblclick)="playMiniGame($event)"
  >
    <img
      *ngIf="showPackAnimation"
      class="custom-avatar pack-avatar"
      [src]="activePackUrl"
      alt=""
      draggable="false"
    />

    <img
      *ngIf="!showPackAnimation && isCustomAvatar"
      class="custom-avatar"
      [src]="prefs.customAvatarDataUrl"
      alt=""
      draggable="false"
    />

    <span
      *ngIf="!showPackAnimation && !isCustomAvatar && prefs.appearance === 'orb'"
      class="orb-avatar"
      aria-hidden="true"
    >
      <span class="orb-core"></span>
      <span class="orb-ring"></span>
    </span>

    <span
      *ngIf="!showPackAnimation && !isCustomAvatar && prefs.appearance !== 'orb'"
      class="robot-avatar"
      aria-hidden="true"
    >
      <span class="antenna">
        <i></i>
      </span>
      <span class="robot-head">
        <span class="robot-face">
          <i class="eye left"></i>
          <i class="eye right"></i>
          <i class="mouth" *ngIf="prefs.mascotStyle.mouth"></i>
        </span>
      </span>
      <span class="robot-body">
        <i class="brand-dot"></i>
      </span>
    </span>

    <span
      *ngIf="prefs.mascotStyle.mouth && (isCustomAvatar || showPackAnimation)"
      class="mascot-part mouth-part"
      aria-hidden="true"
    ></span>

    <span
      *ngIf="prefs.mascotStyle.hands"
      class="mascot-part hand-part left"
      aria-hidden="true"
    ></span>
    <span
      *ngIf="prefs.mascotStyle.hands"
      class="mascot-part hand-part right"
      aria-hidden="true"
    ></span>
    <span
      *ngIf="prefs.mascotStyle.feet"
      class="mascot-part foot-part left"
      aria-hidden="true"
    ></span>
    <span
      *ngIf="prefs.mascotStyle.feet"
      class="mascot-part foot-part right"
      aria-hidden="true"
    ></span>

    <span
      *ngIf="prefs.mascotStyle.hat !== 'none'"
      class="mascot-accessory hat-accessory material-icons"
      [attr.data-hat]="prefs.mascotStyle.hat"
      aria-hidden="true"
    >
      {{ prefs.mascotStyle.hat === 'helmet' ? 'construction' : prefs.mascotStyle.hat === 'artist' ? 'palette' : 'sports_baseball' }}
    </span>

    <span
      *ngIf="prefs.mascotStyle.computer"
      class="mascot-accessory computer-accessory material-icons"
      aria-hidden="true"
    >laptop_mac</span>

    <span
      *ngIf="prefs.mascotStyle.artist"
      class="mascot-accessory artist-accessory material-icons"
      aria-hidden="true"
    >brush</span>

    <span class="online-dot"></span>
  </button>
</div>
